import { useState, useEffect } from "react";
import { api } from "@/contexts/AuthContext";

/**
 * Hook to fetch the default country code from the user's active WhatsApp connection.
 *
 * The backend extracts the dial code from the connected phone number
 * (e.g. +573206807252 → "+57", +525512345678 → "+52").
 *
 * Falls back to "+57" (Colombia) if the API call fails or no connection exists.
 */
export function useDefaultCountryCode() {
  const [defaultCountryCode, setDefaultCountryCode] = useState("+57");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/whatsapp/default-country-code")
      .then((res) => {
        if (res.data?.country_code) {
          setDefaultCountryCode(res.data.country_code);
        }
      })
      .catch(() => {
        /* Silent fallback to +57 */
      })
      .finally(() => setLoading(false));
  }, []);

  return { defaultCountryCode, loading };
}
